<template>
  <div class="customer_progress">
    <div class="title" v-if="progressInfo.percentage > 20">{{progressInfo.title || title}}</div>
    <el-progress
      :text-inside="Boolean(progressInfo.textInside) || textInside"
      :stroke-width="Number(progressInfo.strokeWidth) || strokeWidth"
      :percentage="Number(progressInfo.percentage) || percentage"
      :color="progressInfo.customColor || customColor"
      :format="formatFn"
      :status="progressInfo.status || status" 
    ></el-progress>
    <div
      class="test"
      :style="(progressInfo.percentage === 100 ? 'animation:none;' : '')+'width:' + progressInfo.percentage +'%' "
    ></div>
  </div>
</template>
<script>
export default {
  name: "customer_progress",
  props: {
    progressInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      customColor: "",
      strokeWidth: 24,
      textInside: true,
      percentage: 0,
      completeInfo: "",
      status: "warning", // success/exception/warning 颜色和状态不能同时设置
      title:''
    };
  },
  mounted() {
    console.log(this.progressInfo);
  },
  methods: {
    formatFn: function (percentage) {
      return this.progressInfo.completeInfo || percentage + "%";
    },
  },
};
</script>
<style lang="scss">
.customer_progress {
  position: relative;
  font-weight: bold;
  .el-progress-bar__outer {
    border-radius: 0;
  }
  .el-progress-bar__inner {
   border-radius: 0; 
  }
  .title {
    position: absolute;
    left: 12px;
    z-index: 10;
    font-size: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: #fff;
  }
  .test {
    position: absolute;
    width: 100%;
    height: 100%;
    display: block;
    background-image: repeating-linear-gradient(
      -45deg,
      rgba(255, 255, 255, 0.3) 0,
      rgba(255, 255, 255, 0.3) 12.5%,
      transparent 0,
      transparent 25%
    );
    background-size: 80px 80px;
    top: 0;
    animation: move 2.5s linear infinite;
  }
  .el-progress-bar__innerText {
    margin-right: 15px;
  }
  @keyframes move {
    from {
      background-position: 0;
    }
    to {
      background-position: 80px 0;
    }
  }
}
</style>